import { inject } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { distinctUntilChanged, EMPTY, tap } from 'rxjs';
import { GTMService } from '../services/gtm.service';
import { isServer } from '../utilities/platform-type';
import { consentFeature } from './consent';

export const consentEffects = {
  /**
   * Effect: Update GTM consent based on user state
   * Observes analyticsEnabled selector and updates consent in GTM
   * Triggers:
   * 1. After consentActions.init() reads stored consent from localStorage
   * 2. When user clicks "Accept All" or "Essential Only"
   */
  onConsentChanged: createEffect(
    () => {
      // Skip during SSR
      if (isServer()) {
        return EMPTY;
      }

      const store = inject(Store);
      const gtmService = inject(GTMService);

      return store.select(consentFeature.analyticsEnabled).pipe(
        distinctUntilChanged(),
        tap((enabled) => {
          gtmService.consent$.update(value => {
            return {
              ...value,
              analytics_storage: enabled ? 'granted' : 'denied'
            };
          });
        })
      );
    },
    { functional: true, dispatch: false }
  ),
} as const;
